export default (): string | undefined => {
    const sessionKey = localStorage.getItem('sessionKey')
    return sessionKey === null ? undefined : sessionKey
}
